import { useEffect, useState } from "react";
import { useApp } from "../../contexts/AppContext";

const API_BASE = import.meta.env?.VITE_API_URL ?? "/api";
// Build-injected version: the release tag when built for a release, otherwise the
// short commit SHA. Resolved by CI at build time (VITE_APP_VERSION <- deploy.yml /
// release.yml) so the runtime shows it verbatim — NO tag-vs-hash logic here.
// VITE_GIT_SHA is the raw build commit, kept only for the frontend/API build check.
const APP_VERSION =
  import.meta.env?.VITE_APP_VERSION || import.meta.env?.VITE_GIT_SHA || "dev";
const BUILT_SHA = import.meta.env?.VITE_GIT_SHA ?? "dev";

// Admin-only build-version strip pinned to the bottom of the app shell. Leads with
// the deployed VERSION (already resolved at build), then the API's reported version
// so an admin can spot a frontend/API build mismatch. Hidden for non-admins.
export default function Footer() {
  const { currentUserType } = useApp();
  const [api, setApi] = useState(null); // { version, sha } from GET /version

  const isAdmin = currentUserType === "admin";

  useEffect(() => {
    if (!isAdmin) return;
    let alive = true;
    fetch(`${API_BASE}/version`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => alive && setApi(d))
      .catch(() => alive && setApi({ version: "unreachable", sha: "" }));
    return () => {
      alive = false;
    };
  }, [isAdmin]);

  if (!isAdmin) return null;

  const apiVersion = api?.version ?? "…";
  const mismatch = !!api?.sha && BUILT_SHA !== "dev" && api.sha !== BUILT_SHA;

  return (
    <footer className="flex shrink-0 items-center gap-4 border-t border-(--border-subtle) bg-(--surface-1) px-[30px] py-2 text-[11px] text-(--text-muted)">
      <span>
        version{" "}
        <code className="font-mono text-(--text-primary)">{APP_VERSION}</code>
      </span>
      <span>
        api{" "}
        <code className="font-mono text-(--text-primary)">{apiVersion}</code>
      </span>
      {mismatch ? (
        <span
          className="font-semibold text-amber-600"
          title="Frontend and API are running different builds"
        >
          ⚠ version mismatch
        </span>
      ) : null}
    </footer>
  );
}
